module.exports = __webpack_public_path__ + "media/images/EditPeople-fca779959854b79663b67a5d01536e18.png";